export const formatMailboxNumber = (num: string | undefined): string => {
  if (!num) return "";
  const digits = num.replace(/\D/g, "");
  if (digits.length !== 9) return num;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
};
